/**
 * An enumeration of the application modules.  Primarily used when navigating between modules.
 */
import AppRoute from "common/enums/AppRoute";
import FeatureRight from "common/enums/FeatureRight";
import LicenseModule from "common/enums/LicenseModule";

/**
 * type: "html" or "mobile" - used by windowManager to route the application
 * hash: the deep link to get to the module's page, if it's within the app module (ie app/index.html#dashboardsDesigner)
 * url: the page to get to the module, follows app in the url (ie app/formDesigner/)
 * headerKey: locale key for the browser's title for the module
 * name: the window's name, for window reuse within the application
 */
export default {

    MAIN_HTML: "MAIN_HTML",
    ADMIN: "ADMIN",
    PROCESS_DESIGNER: "PROCESS_DESIGNER",
    FORM_DESIGNER: "FORM_DESIGNER",
    DASHBOARDS: "DASHBOARDS",
    DASHBOARDS_DESIGNER: "DASHBOARDS_DESIGNER",
    EXTERNAL_FORMS: "EXTERNAL_FORMS",
    VIEWER: "VIEWER",
    GATEWAY_DESIGNER: "GATEWAY_DESIGNER",

    // the main app in HTML
    _MAIN_HTML: {
        type: "html",
        hash: AppRoute.MAIN,
        headerKey: "docfinity",
        name: "DocFinity_Main",
        icon: "Y",
        id: "mainHtml",
        text: "main.workspace.title",
        licenses: [LicenseModule.CORE]
    },

    // the admin module
    _ADMIN: {
        type: "html",
        url: "admin",
        hash: AppRoute.ADMIN_LANDING,
        headerKey: "admin.title",
        name: "DocFinity_Admin",
        icon: "G",
        text: "admin",
        id: "admin",
        featureRight: FeatureRight.ADMIN,
        licenses: [
            LicenseModule.CORE,
            LicenseModule.STARTUP
        ]
    },

    // process designer library
    _PROCESS_DESIGNER: {
        type: "html",
        url: "bpmDesigner",
        hash: "",
        headerKey: "menu.bpm",
        name: "DocFinity_Process_Designer_Library",
        icon: "P",
        text: "menu.bpm",
        id: "bpm",
        featureRight: FeatureRight.BPM_DESIGNER,
        licenses: [LicenseModule.BPM]
    },

    // form designer
    _FORM_DESIGNER: {
        type: "html",
        url: "formDesigner",
        hash: "",
        name: "DocFinity_Form_Designer_Library",
        headerKey: "menu.forms",
        icon: "F",
        text: "menu.forms",
        id: "forms",
        featureRight: FeatureRight.FORM_DESIGNER,
        licenses: [LicenseModule.E_FORMS]
    },

    // dashboards
    _DASHBOARDS: {
        type: "html",
        hash: AppRoute.DASHBOARD_VIEWER,
        headerKey: "dashboard.dashboards",
        name: "DocFinity_Dashboards",
        icon: "Q",
        text: "dashboard.dashboards",
        id: "dashboards",
        featureRight: FeatureRight.DASHBOARDS_VIEW,
        licenses: [LicenseModule.DASHBOARDS]
    },

    // dashboards designer
    _DASHBOARDS_DESIGNER: {
        type: "html",
        url: "dashboardDesigner",
        hash: AppRoute.DASHBOARD_DESIGNER_LIBRARY,
        headerKey: "dashboard.designer.title",
        name: "DocFinity_Dashboards_Designer",
        icon: "D",
        text: "dashboard.designer.title",
        id: "dashboardsDesigner",
        featureRight: FeatureRight.DASHBOARDS_MANAGE,
        licenses: [LicenseModule.DASHBOARDS]
    },

    // external forms
    _EXTERNAL_FORMS: {
        type: "external",
        hash: AppRoute.EXTERNAL_FORMS,
        name: "DocFinity_Forms",
        licenses: [LicenseModule.E_FORMS]
    },

    // external viewer
    _VIEWER: {
        type: "html",
        hash: AppRoute.VIEWER,
        name: "DocumentPreviewPanel",
        licenses: [LicenseModule.CORE]
    },

    _GATEWAY_DESIGNER: {
        type: "html",
        hash: "",
        url: "gatewayDesigner",
        headerKey: "gateway.designer.title",
        name: "DocFinity_Gateway_Designer_Library",
        icon: "_",
        text: "gateway.designer.title",
        id: "gatewayDesigner",
        featureRight: FeatureRight.GATEWAYS_MANAGE,
        licenses: [LicenseModule.GATEWAY]
    },

    /**
     * Get the text that should be shown in the h1 header element on the HTML page for this module
     * @param module the module key
     * @returns {string}
     */
    getHeaderText: function(module) {
        return this["_" + module].headerKey;
    },

    /**
     * Open the specified module in a new window.
     * @param module the module key
     */
    openModule: function(module) {
        var obj = this["_" + module],
            targetWindow = window,
            base = "/app/index.html#";

        // set the URL to the window object
        targetWindow.location.href = context.path + base + obj.url;
    },

    listModules: function() {
        return [
            this.MAIN_HTML,
            this.ADMIN,
            this.PROCESS_DESIGNER,
            this.FORM_DESIGNER,
            this.DASHBOARDS_DESIGNER,
            this.DASHBOARDS,
            this.EXTERNAL_FORMS,
            this.VIEWER
        ];
    },

    getDetails: function(module) {
        return this["_" + module];
    }
};
